<div class="row">
    <div class="col-12">
        <h4 class="mb-2 py-1 font-header-1">Menu</h4>
    </div>
</div>

<div class="row mt-2 mb-2">
    <div class="col pl-0">
        <div widget class="card border-0 box-shadow">
            <div class="card-body  widget-body pb-2 pt-1 mb-2">
                <div class="row mt-2 mb-0 meNu-1">
                    <div class="col-4 meNu1">
                        <button type="button" class="btn blue-btn btn-sm" data-bs-toggle="modal" (click)="closeModal()"
                            data-bs-target="#CreateMenumodal" *ngIf="fp.menucreate">Add Menu</button>&nbsp;&nbsp;
                    </div>
                    <div class="col-4 meNu2">
                        <label>Select Menu</label>&nbsp;
                        <ng-select [(ngModel)]="selectMenuFilter" [items]="MenuList" class="w-75"
                            (ngModelChange)="menuListFilter()" [searchable]="true" [clearable]="true" bindLabel="title"
                            bindValue="id"></ng-select>
                    </div>
                    <div class="col-4 meNu3">
                        <button type="button" class="btn btn-sm text-right" (click)="Refresh()">
                            <i class="fa fa-repeat"> </i>Refresh
                        </button>
                    </div>
                </div>
                <!-- ejs -grid -->
                <div class="row mt-3">
                    <div class="col">
                        <ejs-grid #gridMenus [dataSource]='GridList | async' [allowPaging]='true'
                            [pageSettings]='initialPage' [filterSettings]='filterSettings' [allowFiltering]='true'
                            [allowResizing]='true' (dataStateChange)='dataChangeMenus($event)'
                            [showColumnChooser]='true' (actionBegin)="onActionMenus($event)" [allowSorting]='true'>
                            <e-columns>
                                <e-column minWidth=100 headerText="Actions" textAlign="center"
                                    [showInColumnChooser]='false'>
                                    <ng-template #template let-data>
                                        <button class="btn btn-edit-table" data-bs-toggle="modal"
                                            data-bs-target="#CreateMenumodal" (click)="getDetails(data)">
                                            <i class="fa fa-edit" *ngIf="fp.menuupdate"></i></button>&nbsp;
                                        <button class="btn btn-Menu-add-table" (click)="isshowFunction=true;
                                    sideMenuId.Id=data.id;sideMenuId.FunctionName=data.title
                                    " data-bs-toggle="modal" data-bs-target="#FunctionTablemodal"
                                            *ngIf="data.isFunctionRequired">
                                            <i class="fa fa-plus"></i></button>&nbsp;
                                    </ng-template>
                                </e-column>
                                <e-column minWidth=100 field="title" headerText="Title" type="string">
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <e-column minWidth=100 field="icon" headerText="Icon" type="string">
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <e-column minWidth=100 field="link" headerText="Link" type="string">
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <e-column width="50" [showInColumnChooser]='false'>
                                    <ng-template #headerTemplate let-data>
                                        <div>
                                            <span id='show'><i class="fa fa-cog fa-lg" aria-hidden="true"> </i></span>
                                        </div>
                                    </ng-template>
                                </e-column>
                            </e-columns>
                        </ejs-grid>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<!-- For Create & Update Modal -->
<span id="openMenuModal" data-bs-target="#CreateMenumodal" data-bs-toggle="modal"></span>
<div class="modal fade" id="CreateMenumodal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog create-update-zip" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">
                    <span *ngIf="saveMenuInfo.id == '00000000-0000-0000-0000-000000000000'"> Create Menu</span>
                    <span *ngIf="saveMenuInfo.id != '00000000-0000-0000-0000-000000000000'">Update Menu</span>
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="closeModal()"
                    aria-label="Close">
                    <span aria-hidden="true"></span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row" *ngIf="selectMenuFilter!=null && selectMenuFilter!=undefined && selectMenuFilter!=''">
                    <div class="col-lg-6">
                        <label>Menu</label>
                    </div>
                    <div class="col-lg-6">
                        <label>{{MenuNames}}</label>
                    </div>
                </div>
                <div class="row mt-1">
                    <div class="col-lg-5">
                        <label>Title<sup class="super-script">*</sup>
                        </label>
                    </div>
                    <div class="col-lg-7">
                        <input type="text" class="form-control" [(ngModel)]="saveMenuInfo.title">
                    </div>
                </div>
                <div class="row mt-1">
                    <div class="col-lg-5">
                        <label>Icon</label>
                    </div>
                    <div class="col-lg-7">

                        <input type="text" class="form-control" [(ngModel)]="saveMenuInfo.icon">
                    </div>
                </div>

                <div class="row mt-1">
                    <div class="col-lg-5">
                        <label>Link</label>
                    </div>
                    <div class="col-lg-7">

                        <input type="text" class="form-control" [(ngModel)]="saveMenuInfo.link">
                    </div>
                </div>
                <div class="row mt-1">
                    <div class="col-lg-5">
                        <label>Menu Code<sup class="super-script">*</sup></label>
                    </div>
                    <div class="col-lg-7">

                        <input type="text" class="form-control" [(ngModel)]="saveMenuInfo.menuCode">
                    </div>
                </div>

                <div class="row mt-1">
                    <div class="col-lg-5">
                        <label>Order No<sup class="super-script">*</sup></label>
                    </div>
                    <div class="col-lg-7">
                        <input type="number" class="form-control" [(ngModel)]="saveMenuInfo.orderNumber">
                    </div>
                </div>

                <div class="row mt-1">
                    <div class="col-lg-5">
                        <label>Has Function ?</label>
                    </div>
                    <div class="col-lg-7">
                        <input type="checkbox" [(ngModel)]="saveMenuInfo.isFunctionRequired">
                    </div>
                </div>
                <div class="row mt-1">
                    <div class="col-lg-5">
                        <label>SuperAdmin Exclusive?</label>
                    </div>
                    <div class="col-lg-7">
                        <input type="checkbox" [(ngModel)]="saveMenuInfo.isSuperAdminExclusive">
                    </div>
                </div>

            </div>

            <div class="modal-footer">
                <button class="btn blue-btn btn-sm" (click)="SaveOrUpdateMenu();" [disabled]="isSaveorUpdateBoolean || saveMenuInfo.title==null 
                || saveMenuInfo.title==undefined ||
                saveMenuInfo.title=='' ||
                saveMenuInfo.menuCode==null || saveMenuInfo.menuCode==undefined ||
                saveMenuInfo.menuCode=='' || saveMenuInfo.orderNumber==null || saveMenuInfo.orderNumber==undefined 
             ">
                    <span *ngIf="saveMenuInfo.id == '00000000-0000-0000-0000-000000000000'"> Save &
                        Close</span>

                    <span *ngIf="saveMenuInfo.id != '00000000-0000-0000-0000-000000000000'">Update & Close</span>
                </button>
                <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal"
                    (click)="closeModal()">Close</button>
            </div>
        </div>
    </div>
</div>

<!-- Function Modal -->
<div class="modal fade" id="FunctionTablemodal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">Menu Functionality</h5>
                <span></span>&nbsp;&nbsp;&nbsp;
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                    (click)="isshowFunction=false">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12">
                        <app-function-code [InputProperty]="sideMenuId" *ngIf="isshowFunction"></app-function-code>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal"
                    (click)="isshowFunction=false">Close</button>
            </div>
        </div>
    </div>
</div>